import React, { lazy, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { themeChange } from "theme-change";
import { Toaster } from "react-hot-toast";
import checkAuth from "./app/auth";
import initializeApp from "./app/init";
import "./App.css";
import JoiningDocumentSubmission from "./pages/protected/account/JoiningDocumentSubmission";
import TimesheetFillPage from "./features/account/PayRoll/components/TimesheetFillPage";
import OnboardingForm from "./features/account/Unboarding/Components/OnboardingForm";
import MainOnboardingForm from "./features/account/Unboarding/Components/MainOnboardingForm";
import { SocketProvider } from "./features/UtilitiesForSocket/socketUtility.js";
import { useAuth } from "./features/UtilitiesForSocket/socketUtility.js";
import AuthorizePage from "./features/account/InvoiceReport/components/AuthorizePage.jsx";
// Lazy-loaded pages
const Layout = lazy(() => import("./containers/Layout"));
const Login = lazy(() => import("./pages/Login"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));

// Initialize libraries
initializeApp();

// Check authentication
const token = checkAuth();

// Retrieve and parse role safely
const getUserRole = () => {
  try {
    return JSON.parse(localStorage.getItem("workgs-user"))?.role ?? null;
  } catch (error) {
    console.error("Error parsing user data:", error);
    return null;
  }
};

const ROLE = getUserRole();

// Determine initial navigation path
const initialNavigatePath = token
  ? ROLE === "company"
    ? "/app/company-dashboard"
    : ROLE === "admin"
    ? "/app/admin-dashboard"
    : ROLE === "accountant"
    ? "/app/account-dashboard"
    : "/app/dashboard"
  : "/login";

const App = () => {
  useEffect(() => {
    themeChange(false);
  }, []);

  // -------------------------------Disable right click---------------------------------------//

  // useEffect(() => {
  //   const handleContextMenu = (e) => e.preventDefault();
  //   document.addEventListener("contextmenu", handleContextMenu);
  //   const handleKeyDown = (e) => {
  //     if (
  //       e.key === "F12" ||
  //       (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "J")) ||
  //       (e.ctrlKey && e.key === "U")
  //     ) {
  //       e.preventDefault();
  //     }
  //   };
  //   document.addEventListener("keydown", handleKeyDown);

  //   return () => {
  //     document.removeEventListener("contextmenu", handleContextMenu);
  //     document.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, []);

  const { currentUser } = useAuth();
  return (
    <SocketProvider user={currentUser}>
      <Router>
        <Routes>
          <Route path="/authorize/:invoiceId" element={<AuthorizePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/joining-doc" element={<JoiningDocumentSubmission />} />
          <Route path="/timesheet/fill" element={<TimesheetFillPage />} />
          <Route path="/onboarding-form" element={<OnboardingForm />} />
          <Route
            path="/main-onboarding-form"
            element={<MainOnboardingForm />}
          />
          {/* Uncomment if you have a register page */}
          {/* <Route path="/register" element={<Register />} /> */}
          <Route path="/forgot-password" element={<ForgotPassword />} />
          {/* <Route path="/register" element={<Register />} /> */}
          <Route path="/app/*" element={<Layout />} />
          <Route
            path="*"
            element={<Navigate to={initialNavigatePath} replace />}
          />
        </Routes>
        <Toaster />
      </Router>
    </SocketProvider>
  );
};

export default App;
